import { Box } from "@mui/material";
import ToolTip from "components/common/Tooltip";
import { isEmpty } from "lodash";
import { useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { getOwnersDisplayList } from "utils/SharedUtils";

interface Owner {
  code: string;
  name: string;
}

interface Props {
  ownerCodes?: string[];
  userDetailsList?: any[];
  collapse?: boolean;
}

function OwnersList(props: Props) {
  const { ownerCodes, userDetailsList, collapse = false } = props;
  const isAbovePropertyUser = useAppSelector((state) => state.app.loggedInUserDetails.isAbovePropertyUser);
  const resolvedOwners: Owner[] = getOwnersDisplayList(ownerCodes, userDetailsList);

  const owners = isAbovePropertyUser ? resolvedOwners : resolvedOwners.filter((owner) => !isEmpty(owner.name));

  if (!owners.length) return <>-</>;

  const renderOwner = (owner: Owner) =>
    !isEmpty(owner.name) ? (
      <Box component={"span"}>{owner.name}</Box>
    ) : (
      <Box component={"span"} color={tokens.Text.Feedback.Alert}>
        {owner.code}
      </Box>
    );

  if (collapse) {
    return owners.length === 1 ? (
      renderOwner(owners[0])
    ) : (
      <ToolTip title={owners.map((owner) => owner.name || owner.code).join(", ")}>
        <Box component={"span"}>
          {renderOwner(owners[0])} {`+ ${owners.length - 1}`}
        </Box>
      </ToolTip>
    );
  }

  return (
    <>
      {owners.map((owner, index) => (
        <Box component={"span"} key={owner.code}>
          {renderOwner(owner)}
          {index < owners.length - 1 && ", "}
        </Box>
      ))}
    </>
  );
}

export default OwnersList;
